import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { NotificationFlagsCategories } from '../../../../models/NotificationFlags/NotificationFlagsCategories';
import { useSelectedVenueId } from '../../../../slices/venue/use-selected-venue';
import { VenueId } from '../../../../venues/venues.types';
import { paths } from '../../../../routing/path';

const resolveVenueHome = (selectedVenueId: VenueId | null): string => {
    if (!selectedVenueId) {
        return paths.account.venuesHome;
    }
    if (selectedVenueId === VenueId.Connect) {
        return paths.venues.connect.practiceBrokerageServices;
    }
    return paths.venues.byId(selectedVenueId);
};

export interface HomeMenuItemProps {
    className?: string;
    marginLeft?: number;
    label?: string;
    to?: string;
}

export const HomeMenuItem = (props: HomeMenuItemProps) => {
    const selectedVenueId = useSelectedVenueId();
    const to = props.to ?? resolveVenueHome(selectedVenueId);

    return (
        <LeftMenuItem
            icon="pe-7s-home"
            label={props.label ?? 'Home'}
            to={to}
            flagCode={NotificationFlagsCategories.AnnouncementsCode}
            className={props.className}
            marginLeft={props.marginLeft}
            trackingAction="Home"
            gtmCategory="Home"
        />
    );
};
